var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/*
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import { loadState } from '@nextcloud/initial-state';
var ConfigService = /** @class */ (function () {
    function ConfigService() {
        this.values = __assign({ wopi_callback_url: loadState('richdocuments', 'wopi_callback_url', '') }, loadState('richdocuments', 'document', {}));
    }
    ConfigService.prototype.update = function (key, value) {
        this.values[key] = value;
    };
    ConfigService.prototype.get = function (key) {
        return this.values[key];
    };
    return ConfigService;
}());
var Config = new ConfigService();
export default Config;
